import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { lazy } from 'react';
import ContractLotRouter from './routes/ContractLotRouter';
import ContractRouter from './routes/ContractRouter';
import ContractLaborRouter from './routes/ContractLaborRouter';
import PageErrorRouter from './routes/PageErrorRouter';
import SubmissionRouter from './routes/SubmissionRouter';
import DocumentRouter from './routes/DocumentRouter';
import ReferenceTemplateRouter from './routes/ReferenceTemplateRouter';

//pages
const LoadingContractForm = lazy(() => import('components/loadingUi/contract-document/LoadingContractForm'));
const Home = lazy(() => import('features/home/Home'));
const EmptyPage = lazy(() => import('components/EmptyPage/EmptyPage'));
const Users = lazy(() => import('features/users/pages/Users'));

const CategoryDocumentType = lazy(
    () => import('features/category-document-type/document-type/pages/CategoryDocumentType')
);

const CategoryIncomingDoc = lazy(() => import('features/category-incoming-doc/pages/CategoryIncomingDoc'));
const CategorySentDoc = lazy(() => import('features/category-sent-doc/pages/CategorySentDoc'));
const Roles = lazy(() => import('features/roles/pages/Roles'));
const WrapConfig = lazy(() => import('features/config/WrapConfig'));
const ConfigDigitalCertificate = lazy(
    () => import('features/config-digital-certificate/pages/ConfigDigitalCertificate')
);
const OrganizationTree = lazy(() => import('features/organization-tree/pages/OrganizationTree'));
const EmailTemplate = lazy(() => import('features/category-mail/pages/EmailTemplate'));
const EmailTemplateEdit = lazy(() => import('features/category-mail/pages/EmailTemplateEdit'));
const EmailTemplateEditUpgrade = lazy(() => import('features/category-mail/pages/EmailTemplateEditUpgrade'));
const CategoryPosition = lazy(() => import('features/category-position/pages/CategoryPosition'));
const CategoryTypeProcedure = lazy(() => import('features/category-type-procedure/pages/CategoryTypeProcedure'));
const CategoryProcedure = lazy(() => import('features/category-procedure/pages/CategoryProcedure'));
const CategoryProcedureAdd = lazy(() => import('features/category-procedure/pages/CategoryProcedureAdd'));
const CategoryProcedureEdit = lazy(() => import('features/category-procedure/pages/CategoryProcedureEdit'));

// * hồ sơ hợp đồng
const ContractDocument = lazy(
    () => import('features/contract-document/contract-document-manager/pages/ContractDocument')
);
const ContractDocumentAdd = lazy(
    () => import('features/contract-document/contract-document-manager/pages/ContractDocumentAdd')
);
const ContractDocumentGroup = lazy(
    () => import('features/contract-document/contract-document-manager/pages/ContractDocumentGroup')
);
const ContractDocumentPosition = lazy(
    () => import('features/contract-document/contract-document-manager/pages/pdf-contract/ContractDocumentPosition')
);
const ContractDocumentViewEnd = lazy(
    () => import('features/contract-document/contract-document-manager/pages/contract-view/ContractDocumentViewEnd')
);
const ContractDocumentEdit = lazy(
    () => import('features/contract-document/contract-document-manager/pages/ContractDocumentEdit')
);
const ContractDocumentView = lazy(
    () => import('features/contract-document/contract-document-manager/pages/contract-view/ContractDocumentView')
);
// * phê duyệt hồ sơ hợp đồng
const ContractDocumentConfirm = lazy(
    () => import('features/contract-document/contract-document-confirm/pages/ContractDocumentConfirm')
);
const ContractDocumentConfirmView = lazy(
    () => import('features/contract-document/contract-document-confirm/pages/ContractDocumentConfirmView')
);

const CategoryContractType = lazy(() => import('features/category-contract-type/pages/CategoryContractType'));
const CategoryContractTypeAdd = lazy(() => import('features/category-contract-type/pages/CategoryContractTypeAdd'));
const CategoryContractTypeEdit = lazy(() => import('features/category-contract-type/pages/CategoryContractTypeEdit'));
const ContractComplaints = lazy(() => import('features/contract-complaints/pages/ContractComplaints'));
const ContractComplaintsAdd = lazy(() => import('features/contract-complaints/pages/ContractComplaintsAdd'));
const PersonalDocument = lazy(() => import('features/personal-document/pages/PersonalDocument'));
const PageSignMultiFile = lazy(
    () => import('features/personal-document/components/sign-multi-document/PageSignMultiFile')
);
const SignTemplate = lazy(() => import('features/sign-template/pages/SignTemplate'));
const ChangePassWord = lazy(() => import('features/users/pages/change-password/ChangePassWord'));
const Profile = lazy(() => import('features/users/pages/profile/Profile'));
const ChangeOrganization = lazy(() => import('features/users/pages/change-organization/ChangeOrganization'));
const MailingHistory = lazy(() => import('features/mailing-history/pages/MailingHistory'));
const UserManual = lazy(() => import('features/User-Manual/UserManual'));
const ConfigStorage = lazy(() => import('features/config-storage/ConfigStorage'));

const QuickWizard = lazy(() => import('features/Quick-Wizard/QuickWizard'));
const CategoryReleaseNote = lazy(() => import('features/category-release-note/pages/CategoryReleaseNote'));

const SynthesisReport = lazy(() => import('features/category-report/synthesis-report/pages/SynthesisReport'));
const DetailsReport = lazy(() => import('features/category-report/synthesis-report/pages/DetailsReport'));
const Partner = lazy(() => import('features/partner/pages/Partner'));
const AuthorityManager = lazy(() => import('features/authority-manager/pages/AuthorityManager'));
// const TicketSupportAdd = lazy(() => import('features/ticket_support/TicketSupportAdd'));

// nhóm phê duyệt
const CategoryApprovalGroup = lazy(() => import('features/category-approval-group/pages/CategoryApprovalGroup'));
const ServiceManager = lazy(() => import('features/service-manager/pages/ServiceManager'));
const StaffManagement = lazy(() => import('features/staff-management/pages/StaffManagement'));

const StaffDetail = lazy(() => import('features/staff-management/pages/StaffDetail'));

// import EmptyPage from 'components/EmptyPage';

const Routes = [
    {
        path: '/',
        exact: true,
        component: Home,
    },
    {
        path: routerMain.HOME,
        exact: true,
        component: Home,
    },

    {
        path: routerMain.LOADING,
        exact: true,
        component: LoadingContractForm,
    },

    {
        path: routerMain.NONE,
        exact: true,
        component: Home,
    },
    {
        path: routerMain.EMPTY,
        exact: true,
        component: EmptyPage,
    },
    {
        path: routerMain.USER,
        exact: true,
        component: Users,
    },
    {
        path: routerMain.CATEGORY_DOCUMENT_TYPE,
        exact: true,
        component: CategoryDocumentType,
    },
    {
        path: routerMain.CATEGORY_DOCUMENT_INCOMING,
        exact: true,
        component: CategoryIncomingDoc,
    },
    {
        path: routerMain.CATEGORY_DOCUMENT_SENT,
        exact: true,
        component: CategorySentDoc,
    },
    {
        path: routerMain.ROLE,
        exact: true,
        component: Roles,
    },
    {
        path: routerMain.CONFIG,
        exact: true,
        component: WrapConfig,
    },
    {
        path: routerMain.CONFIG_DIGITAL_CERTIFICATE,
        exact: true,
        component: ConfigDigitalCertificate,
    },
    {
        path: routerMain.ORGANIZATION_TREE,
        exact: true,
        component: OrganizationTree,
    },
    {
        path: routerMain.EMAIL_TEMPLATE,
        exact: true,
        component: EmailTemplate,
    },
    {
        path: `${routerMain.EMAIL_TEMPLATE}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: EmailTemplateEdit,
    },
    {
        path: `${routerMain.EMAIL_TEMPLATE}${routerPathMain.UPGRADE}/:uuid`,
        exact: true,
        component: EmailTemplateEditUpgrade,
    },
    {
        path: routerMain.CATEGORY_POSITION,
        exact: true,
        component: CategoryPosition,
    },
    {
        path: routerMain.CATEGORY_TYPE_PROCEDURE,
        exact: true,
        component: CategoryTypeProcedure,
    },
    {
        path: routerMain.CATEGORY_PROCEDURE,
        exact: true,
        component: CategoryProcedure,
    },
    {
        path: `${routerMain.CATEGORY_PROCEDURE}${routerPathMain.ADD}`,
        exact: true,
        component: CategoryProcedureAdd,
    },
    {
        path: `${routerMain.CATEGORY_PROCEDURE}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: CategoryProcedureEdit,
    },
    ...ContractRouter,
    ...ContractLaborRouter,
    ...ContractLotRouter,
    ...DocumentRouter,
    // * hồ sơ hợp đồng
    {
        path: routerMain.CONTRACT_DOCUMENT,
        exact: true,
        component: ContractDocument,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.ADD}`,
        exact: true,
        component: ContractDocumentAdd,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.ADD}/:uuid`,
        exact: true,
        component: ContractDocumentAdd,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.ADD}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractDocumentGroup,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.ADD}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractDocumentPosition,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.ADD}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractDocumentViewEnd,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: ContractDocumentEdit,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.EDIT}${routerPathMain.GROUP}/:uuid`,
        exact: true,
        component: ContractDocumentGroup,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.EDIT}${routerPathMain.POSITION}/:uuid`,
        exact: true,
        component: ContractDocumentPosition,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.EDIT}${routerPathMain.END}/:uuid`,
        exact: true,
        component: ContractDocumentViewEnd,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractDocumentView,
    },
    {
        path: routerMain.CONTRACT_DOCUMENT_CONFIRM,
        exact: true,
        component: ContractDocumentConfirm,
    },
    {
        path: `${routerMain.CONTRACT_DOCUMENT_CONFIRM}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: ContractDocumentConfirmView,
    },
    // * end hồ sơ hợp đồng
    {
        path: routerMain.CATEGORY_CONTRACT_TYPE,
        exact: true,
        component: CategoryContractType,
    },
    {
        path: `${routerMain.CATEGORY_CONTRACT_TYPE}${routerPathMain.ADD}`,
        exact: true,
        component: CategoryContractTypeAdd,
    },
    {
        path: `${routerMain.CATEGORY_CONTRACT_TYPE}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: CategoryContractTypeEdit,
    },
    {
        path: routerMain.CONTRACT_COMPLAINTS,
        exact: true,
        component: ContractComplaints,
    },
    {
        path: `${routerMain.CONTRACT_COMPLAINTS}${routerPathMain.ADD}`,
        exact: true,
        component: ContractComplaintsAdd,
    },
    {
        path: routerMain.PERSONAL_DOCUMENT,
        exact: true,
        component: PersonalDocument,
    },
    {
        path: routerMain.SIGN_MULTIPLE,
        exact: true,
        component: PageSignMultiFile,
    },
    {
        path: `${routerMain.PERSONAL_DOCUMENT}/:menu/`,
        exact: true,
        component: PersonalDocument,
    },
    {
        path: `${routerMain.PERSONAL_DOCUMENT}/:menu/:folderId`,
        exact: true,
        component: PersonalDocument,
    },
    {
        path: routerMain.SIGN_TEMPLATE,
        exact: true,
        component: SignTemplate,
    },
    {
        path: routerMain.CHANGE_PASS_WORD,
        exact: true,
        component: ChangePassWord,
    },
    {
        path: routerMain.PROFILE,
        exact: true,
        component: Profile,
    },
    {
        path: routerMain.CHANGE_ORGANIZATION,
        exact: true,
        component: ChangeOrganization,
    },
    {
        path: routerMain.MAILING_HISTORY,
        exact: true,
        component: MailingHistory,
    },

    {
        path: routerMain.USER_MANUAL,
        exact: true,
        component: UserManual,
    },
    {
        path: routerMain.CONFIG_STORAGE,
        exact: true,
        component: ConfigStorage,
    },
    {
        path: routerMain.QUICK_WIZARD,
        exact: true,
        component: QuickWizard,
    },
    {
        path: routerMain.RELEASE_NOTE,
        exact: true,
        component: CategoryReleaseNote,
    },

    {
        path: routerMain.SYNTHESIS_REPORT,
        exact: true,
        component: SynthesisReport,
    },
    {
        path: `${routerMain.SYNTHESIS_REPORT}${routerPathMain.VIEW}/:uuid/:from_date/:to_date`,
        exact: true,
        component: DetailsReport,
    },
    {
        path: routerMain.PARTNER,
        exact: true,
        component: Partner,
    },
    {
        path: routerMain.AUTHORITY_MANAGER,
        exact: true,
        component: AuthorityManager,
    },
    {
        path: routerMain.APPROVAL_GROUP,
        exact: true,
        component: CategoryApprovalGroup,
    },
    {
        path: routerMain.SERVICE_MANAGER,
        exact: true,
        component: ServiceManager,
    },
    // {
    //     path: routerMain.CREATE_TICKET_SUPPORT,
    //     exact: true,
    //     component: TicketSupportAdd,
    // },
    ...SubmissionRouter,
    ...ReferenceTemplateRouter,
    {
        path: routerMain.STAFF_MANAGEMENT,
        exact: true,
        component: StaffManagement,
    },
    {
        path: `${routerMain.STAFF_MANAGEMENT}${routerPathMain.ADD}`,
        exact: true,
        component: StaffDetail,
    },
    {
        path: `${routerMain.STAFF_MANAGEMENT}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: StaffDetail,
    },
    {
        path: `${routerMain.STAFF_MANAGEMENT}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: StaffDetail,
    },
    ...PageErrorRouter,
];

const RoutesEContract = [
    {
        path: '/',
        exact: true,
        component: Home,
    },
    {
        path: routerMain.HOME,
        exact: true,
        component: Home,
    },
    {
        path: routerMain.LOADING,
        exact: true,
        component: LoadingContractForm,
    },

    {
        path: routerMain.NONE,
        exact: true,
        component: Home,
    },
    {
        path: routerMain.EMPTY,
        exact: true,
        component: EmptyPage,
    },
    {
        path: routerMain.USER,
        exact: true,
        component: Users,
    },
    {
        path: routerMain.CONFIG_STORAGE,
        exact: true,
        component: ConfigStorage,
    },
    {
        path: routerMain.CATEGORY_DOCUMENT_TYPE,
        exact: true,
        component: CategoryDocumentType,
    },
    {
        path: routerMain.ROLE,
        exact: true,
        component: Roles,
    },
    {
        path: routerMain.CONFIG,
        exact: true,
        component: WrapConfig,
    },
    {
        path: routerMain.CONFIG_DIGITAL_CERTIFICATE,
        exact: true,
        component: ConfigDigitalCertificate,
    },
    {
        path: routerMain.ORGANIZATION_TREE,
        exact: true,
        component: OrganizationTree,
    },
    {
        path: routerMain.EMAIL_TEMPLATE,
        exact: true,
        component: EmailTemplate,
    },
    {
        path: `${routerMain.EMAIL_TEMPLATE}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: EmailTemplateEdit,
    },
    {
        path: `${routerMain.EMAIL_TEMPLATE}${routerPathMain.UPGRADE}/:uuid`,
        exact: true,
        component: EmailTemplateEditUpgrade,
    },

    {
        path: routerMain.CATEGORY_TYPE_PROCEDURE,
        exact: true,
        component: CategoryTypeProcedure,
    },
    {
        path: routerMain.CATEGORY_PROCEDURE,
        exact: true,
        component: CategoryProcedure,
    },
    {
        path: `${routerMain.CATEGORY_PROCEDURE}${routerPathMain.ADD}`,
        exact: true,
        component: CategoryProcedureAdd,
    },
    {
        path: `${routerMain.CATEGORY_PROCEDURE}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: CategoryProcedureEdit,
    },
    ...ContractRouter,
    ...ContractLaborRouter,
    ...ContractLotRouter,
    {
        path: routerMain.CATEGORY_CONTRACT_TYPE,
        exact: true,
        component: CategoryContractType,
    },
    {
        path: `${routerMain.CATEGORY_CONTRACT_TYPE}${routerPathMain.ADD}`,
        exact: true,
        component: CategoryContractTypeAdd,
    },
    {
        path: `${routerMain.CATEGORY_CONTRACT_TYPE}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: CategoryContractTypeEdit,
    },
    {
        path: routerMain.SIGN_MULTIPLE,
        exact: true,
        component: PageSignMultiFile,
    },

    {
        path: routerMain.SIGN_TEMPLATE,
        exact: true,
        component: SignTemplate,
    },
    {
        path: routerMain.CHANGE_PASS_WORD,
        exact: true,
        component: ChangePassWord,
    },
    {
        path: routerMain.PROFILE,
        exact: true,
        component: Profile,
    },
    {
        path: routerMain.CHANGE_ORGANIZATION,
        exact: true,
        component: ChangeOrganization,
    },
    {
        path: routerMain.MAILING_HISTORY,
        exact: true,
        component: MailingHistory,
    },

    {
        path: routerMain.USER_MANUAL,
        exact: true,
        component: UserManual,
    },
    {
        path: routerMain.QUICK_WIZARD,
        exact: true,
        component: QuickWizard,
    },
    {
        path: routerMain.RELEASE_NOTE,
        exact: true,
        component: CategoryReleaseNote,
    },

    {
        path: routerMain.SYNTHESIS_REPORT,
        exact: true,
        component: SynthesisReport,
    },
    {
        path: `${routerMain.SYNTHESIS_REPORT}${routerPathMain.VIEW}/:uuid/:from_date/:to_date`,
        exact: true,
        component: DetailsReport,
    },
    {
        path: routerMain.PARTNER,
        exact: true,
        component: Partner,
    },
    {
        path: routerMain.SERVICE_MANAGER,
        exact: true,
        component: ServiceManager,
    },
    // tài liệu cá nhân
    {
        path: routerMain.PERSONAL_DOCUMENT,
        exact: true,
        component: PersonalDocument,
    },
    {
        path: routerMain.SIGN_MULTIPLE,
        exact: true,
        component: PageSignMultiFile,
    },
    {
        path: `${routerMain.PERSONAL_DOCUMENT}/:menu/`,
        exact: true,
        component: PersonalDocument,
    },
    {
        path: `${routerMain.PERSONAL_DOCUMENT}/:menu/:folderId`,
        exact: true,
        component: PersonalDocument,
    },
    // {
    //     path: routerMain.CREATE_TICKET_SUPPORT,
    //     exact: true,
    //     component: TicketSupportAdd,
    // },
    ...SubmissionRouter,
    ...DocumentRouter,
    ...ReferenceTemplateRouter,
    {
        path: routerMain.STAFF_MANAGEMENT,
        exact: true,
        component: StaffManagement,
    },
    {
        path: `${routerMain.STAFF_MANAGEMENT}${routerPathMain.ADD}`,
        exact: true,
        component: StaffDetail,
    },
    {
        path: `${routerMain.STAFF_MANAGEMENT}${routerPathMain.EDIT}/:uuid`,
        exact: true,
        component: StaffDetail,
    },
    {
        path: `${routerMain.STAFF_MANAGEMENT}${routerPathMain.VIEW}/:uuid`,
        exact: true,
        component: StaffDetail,
    },
    ...PageErrorRouter,
];

export { Routes, RoutesEContract };
